'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _actions = require('../../actions');

var _UserIcon = require('../Icon/UserIcon');

var _UserIcon2 = _interopRequireDefault(_UserIcon);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapperStyle = function wrapperStyle() {
  return {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%'
  };
};

var buttonStyle = function buttonStyle() {
  return {
    width: '100%',
    height: '100%',
    padding: '0 16px',
    border: 'none',
    borderRadius: '0',
    position: 'relative',
    textTransform: 'none',
    fontSize: '14px',
    color: '#fff',
    display: 'inline-flex',
    alignItems: 'center',
    opacity: 1,
    outline: 'none',
    '&:hover, &:focus': {
      textDecoration: 'none',
      color: '#fff'
    }
  };
};

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);
var Button = (0, _preactFela.createComponentWithProxy)(buttonStyle);

var headerGoSignUp = function headerGoSignUp(evt) {
  (0, _actions.goSignUp)(evt, 'perfil');
};

var HeaderProfileIcon = function HeaderProfileIcon(props) {
  var signUp = props.signUp;


  var signUpPath = signUp.path;
  var signUpAccessibleLabel = signUp.signUpAccessibleLabel;
  var signUpEl = typeof signUp.callback === 'function' ? 'button' : 'a';

  return (0, _preact.h)(
    Wrapper,
    null,
    (0, _preact.h)(
      Button,
      _extends({
        href: signUpPath,
        onClick: headerGoSignUp,
        as: signUpEl,
        'aria-label': signUpAccessibleLabel
      }, (0, _utils.getAttrsGtm)(signUpEl, { clicktype: 'menu' })),
      (0, _preact.h)(_UserIcon2.default, { width: 22, height: 22 })
    )
  );
};

exports.default = HeaderProfileIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/HeaderProfileIcon.js
// module id = 202
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38